import { Mail, MapPin, Phone } from "lucide-react";

const SOCIALS = [
  {
    label: "Facebook Kementerian Kesehatan RI",
    href: "https://www.facebook.com/KementerianKesehatanRI",
    path: "M14 8h3V4h-3c-2.8 0-4 1.8-4 4.5V11H7v4h3v9h4v-9h3l1-4h-4V9c0-.6.4-1 1-1z",
  },
  {
    label: "X (Twitter) Kementerian Kesehatan RI",
    href: "https://x.com/KemenkesRI",
    path: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z",
  },
];

/** Footer Kemenkes; dipakai oleh semua layout beranda. */
export function SiteFooter() {
  return (
    <footer className="border-t bg-card text-subtle-foreground">
      <div className="mx-auto flex max-w-[1360px] flex-col gap-6 px-5 pt-9 pb-6 text-sm sm:px-8 lg:px-12">
        <div className="flex flex-wrap justify-between gap-x-10 gap-y-7">
          <div className="flex flex-col gap-2.5">
            <span className="text-base font-bold tracking-wide text-foreground">KEMENTERIAN KESEHATAN RI</span>
            <span>Sekretariat Jenderal - Biro Pengadaan Barang dan Jasa</span>
            <span className="flex items-start gap-2">
              <MapPin className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
              Gedung Sujudi, Lt. 14 - Jl. H.R. Rasuna Said Blok X-5 Kav. 4-9 Jakarta Selatan
            </span>
          </div>
          <div className="flex flex-col gap-2.5 sm:items-end">
            <span className="text-base font-bold text-foreground">Hubungi Kami</span>
            <a href="mailto:katalogsektoral@kemkes.go.id" className="flex items-center gap-2 hover:text-primary">
              <Mail className="size-4 shrink-0" aria-hidden="true" />
              email: katalogsektoral@kemkes.go.id
            </a>
            <a
              href="https://wa.me/6281285972209"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:text-primary"
            >
              <Phone className="size-4 shrink-0" aria-hidden="true" />
              WA Helpdesk: +62 812 8597 2209
            </a>
            <div className="flex items-center gap-4 pt-1">
              {SOCIALS.map((s) => (
                <a
                  key={s.href}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="hover:text-primary"
                >
                  <svg viewBox="0 0 24 24" className="size-[18px] fill-current" aria-hidden="true">
                    <path d={s.path} />
                  </svg>
                </a>
              ))}
              <a
                href="https://www.instagram.com/kemenkes_ri"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram Kementerian Kesehatan RI"
                className="hover:text-primary"
              >
                <svg
                  viewBox="0 0 24 24"
                  className="size-[18px]"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  aria-hidden="true"
                >
                  <rect x="3" y="3" width="18" height="18" rx="5" />
                  <circle cx="12" cy="12" r="4" />
                  <circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <hr />
        <p className="text-center text-[13px] text-muted-foreground">
          © {new Date().getFullYear()} Kementerian Kesehatan Republik Indonesia. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}
